const pharmacy = `Hei, minulla on ollut jatkuva päänsärky parin viime päivän ajan.
ja mietin, voisitko suositella jotain lääkkeitä, jotka auttaisivat lievittämään kipua.
Se on ollut melko rasittavaa, ja olisin kiitollinen kaikesta avusta, jota voisitte antaa.
Kiitos.`;
export default pharmacy;